import React from 'react';

interface SendPicModalProps {
    picture: {
        url: string;
        name: string;
        comment?: string;
    };
    onClose: () => void;
}

const SendPicModal: React.FC<SendPicModalProps> = ({ picture, onClose }) => {
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="close-button" onClick={onClose}>×</button>
                <div className="modal-image-container">
                    <img src={picture.url} alt={picture.name} />
                </div>
                <div className="modal-details">
                    <h3>{picture.name}</h3>
                    {picture.comment && <p>{picture.comment}</p>}
                </div>
            </div>
        </div>
    );
};

export default SendPicModal;